var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 533,
    height: 288,
    viewBox: "0 0 533 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.057 254.698V32.4384C532.057 14.5232 517.505 0 499.555 0L32.5014 0C14.5515 0 0.00012207 14.5232 0.00012207 32.4384V254.698C0.00012207 272.613 14.5515 287.136 32.5014 287.136L499.555 287.136C517.505 287.136 532.057 272.613 532.057 254.698Z",
    fill: "#F00C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M528.662 254.697V32.4379C528.662 16.3934 515.63 3.38672 499.554 3.38672L32.5002 3.38672C16.4246 3.38672 3.39276 16.3934 3.39276 32.4379V254.697C3.39276 270.742 16.4246 283.748 32.5002 283.748L499.554 283.748C515.63 283.748 528.662 270.742 528.662 254.697Z",
    fill: "#FDF6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.565 11.2903H32.5113C20.8092 11.2903 11.3228 20.7584 11.3228 32.4379V254.697C11.3228 266.377 20.8092 275.845 32.5113 275.845H499.565C511.267 275.845 520.754 266.377 520.754 254.697V32.4379C520.754 20.7584 511.267 11.2903 499.565 11.2903Z",
    fill: "#2439BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M511.693 254.697V32.4383C511.693 25.7473 506.258 20.3232 499.554 20.3232L32.5004 20.3232C25.7965 20.3232 20.3619 25.7473 20.3619 32.4383V254.697C20.3619 261.388 25.7965 266.812 32.5004 266.812H499.554C506.258 266.812 511.693 261.388 511.693 254.697Z",
    fill: "#CBF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinBoard);
export default __webpack_public_path__ + "static/media/WinBoard.c32ea07c86cc0703551a.svg";
export { ForwardRef as ReactComponent };